import { render, staticRenderFns } from "./formSelectView.vue?vue&type=template&id=2f1045f6&scoped=true&"
import script from "./formSelectView.vue?vue&type=script&lang=js&"
export * from "./formSelectView.vue?vue&type=script&lang=js&"
import style0 from "./formSelectView.vue?vue&type=style&index=0&id=2f1045f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1045f6",
  null
  
)

export default component.exports